'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconMicrophone, iconMicrophoneTag } from '@ni/nimble-components/dist/esm/icons/microphone';
import { wrap } from '../../utilities/react-wrapper';

export type { IconMicrophone };
export { iconMicrophoneTag };
export const NimbleIconMicrophone = wrap(IconMicrophone);